import AOCollection from './AOCollection';
import ReduxConstants from '../../constants/ReduxConstants';
import dataModel from '../../models/DataModel';
import userService from '../../services/userService';

export default class MarketUsersCollection extends AOCollection {
  /**
   * @param {object} filter - has the following properties:
   *  - searchString (string)
   *  - sortField (string)
   *  - ascending (boolean)
   *  - showDisabled (boolean)
   *  - companyId (number)
   *  - userType (string)
   */
  constructor(perPage, filter, userId, companyId, recordDescriptor, marketId) {
    super({
      name: ReduxConstants.USERS,
      collectionType: ReduxConstants.USER,
      perPage,
      filter,
      userId,
      companyId,
      recordDescriptor,
      subKey: marketId,
    });
    this.marketId = marketId;
  }
  static build(perPage, filter, userId, companyId, recordDescriptor, subKey, marketId) {
    const collection = new MarketUsersCollection(perPage, filter, userId, companyId || localStorage.current_company_id, recordDescriptor, marketId);
    const collectionData = dataModel.collectionsDAO.findCollection(collection.getKey());
    if (!collectionData) {
      collection._recordState = '';
      dataModel.collectionsDAO.setCollection(collection.getKey(), collection.getData(), collection.getCollectionType(), recordDescriptor);
    }
    else {
      collection._filter = collectionData._filter;
      collection.ids = collectionData.ids;
      collection.page = collectionData.page;
      collection.perPage = collectionData.perPage;
      collection.meta = collectionData.meta;
      collection.recordDescriptor = collectionData.recordDescriptor;
    }
    return collection;
  }

  handleOffLineFetch(options) {
    return new Promise((resolve) => {
      let denormalizedCollection = this.getDenormalizedCollection(options);
      resolve(denormalizedCollection);
    });
  }

  async fetchNext(pageOverride, options = {}, prefetchCallback) {
    if (!options.recordDescriptor) {
      options.recordDescriptor = this.recordDescriptor;
    }
    if (dataModel.isOffline) {
      return this.handleOffLineFetch(options);
    }
    else {
      if (pageOverride) {
        this.page = pageOverride;
      }
      else this.page++;

      const { sortField, ascending, deactivated } = this._filter;
      let serviceCall = userService.getUsers.bind(this, this.page, this.perPage, sortField, ascending, deactivated, this.marketId, this.companyId, options);
      let newCollection = await this._fetchData(serviceCall, options, true, null, prefetchCallback);
      if (newCollection.offline) {
        return this.handleOffLineFetch(options);
      }
      return newCollection;
    }
  }

  async fetchCurrent(shouldPaginate = true, options = {}, prefetchCallback) {
    if (!options.recordDescriptor) {
      options.recordDescriptor = this.recordDescriptor;
    }
    if (dataModel.isOffline) {
      return this.handleOffLineFetch(options);
    }
    else {
      let collection = this.findCollection();

      let page = null;
      let perPage = null;
      
      // Get everything we already got
      if (shouldPaginate) {
        page = 1;
        if (collection && collection.perPage) {
          perPage = Math.max(this.perPage, collection.ids.length);
        }
      }

      const { sortField, ascending, deactivated } = this._filter;
      let serviceCall = userService.getUsers.bind(this, page, perPage, sortField, ascending, deactivated, this.marketId, this.companyId, options);

      let newCollection = await this._fetchData(serviceCall, options, false, null, prefetchCallback);
      if (newCollection.offline) {
        return this.handleOffLineFetch(options);
      }
      return newCollection;
    }
  }
}



// WEBPACK FOOTER //
// ./src/dao/collections/MarketUsersCollection.js